export default function PhotosPage() {
  return (
    <div className="container mt-5">
      <h1>Photos</h1>
      <p>For privacy, you must log in with BSD SSO to continue.</p>
    </div>
  );
}